import { faBan } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";

import type { ExternalPageTypeEnum } from "generated/graphqlExternal";
import { formatDateWithTime } from "utils/formatDate";

import { apiTranslate } from "@/translations/i18n";
import ExternalStateMessage from "./ExternalStateMessage";

interface IInviteCanceledProps {
  canceledAt?: string | null;
  inviteType: ExternalPageTypeEnum;
}

const InviteCanceled: React.FC<IInviteCanceledProps> = ({ canceledAt, inviteType }) => {
  const { t } = useTranslation();

  return (
    <ExternalStateMessage
      icon={faBan}
      headerTitle={apiTranslate(`enums.external_page_type_enum.${inviteType}`)}
      title={t("external_invite.canceled.title", { context: inviteType })}
      description={t("external_invite.canceled.description", {
        context: inviteType,
        date: formatDateWithTime(canceledAt),
      })}
      tip={t("external_invite.canceled.tip", { context: inviteType })}
      dataCy="externalInviteCanceled"
    />
  );
};

export default InviteCanceled;
